<script>
export default {
    name: 'IlluProfMusique',
    props: {
        primaryColor: {
            type: String,
            default: '#31A4A7',
        },

        secondaryColor: {
            type: String,
            default: '#313132',
        },
    },
}
</script>
<template>
    <svg role="img"
        class="base-illu illu-prof-musique"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="none" fill-rule="evenodd">
            <path
                d="M27.084 28.5c-4.31 0-8.294 1.398-11.522 3.767A19.54 19.54 0 008.525 42a19.54 19.54 0 007.038 9.734A19.412 19.412 0 0027.084 55.5c4.31 0 8.294-1.398 11.522-3.767A19.54 19.54 0 0045.644 42a19.54 19.54 0 00-7.038-9.734A19.412 19.412 0 0027.084 28.5zm0-20c-2.07 0-3.946.84-5.303 2.197A7.477 7.477 0 0019.584 16c0 2.071.84 3.946 2.197 5.303a7.477 7.477 0 005.303 2.197c2.071 0 3.946-.84 5.304-2.197A7.477 7.477 0 0034.584 16c0-2.071-.84-3.946-2.196-5.303A7.477 7.477 0 0027.084 8.5z"
                :stroke="secondaryColor"
                class="secondary-color"
            />
            <path
                d="M39.581 28.127c-.868 0-1.559-.244-1.999-.707-.37-.429-.582-.979-.582-1.488 0-1.064.813-2.032 2.122-2.525.898-.348 1.775-.322 2.504-.179V11.915L54.364 9v12.665c0 1.085-.397 1.986-1.179 2.679-.834.701-1.865 1.097-2.837 1.097-.867 0-1.533-.238-1.978-.709-.372-.429-.582-.978-.582-1.486 0-.932.624-1.805 1.668-2.332.495-.243 1.3-.491 1.801-.491.431 0 .842.041 1.218.119v-7.16l-8.96 2.108v8.88c0 .535-.154 1.281-.35 1.698-.546 1.12-2.185 2.059-3.584 2.059"
                :fill="primaryColor"
                class="primary-color"
            />
        </g>
    </svg>
</template>
